import { PermissionTableRowType } from '../../../../../../types/common/PermissionType';
import { PERMISSION_ACTIONS, PERMISSION_SUBJECTS } from '../../../../../../constants/service/common/userPermissions';
/*
생성/등록/추가 : create
삭제/제거 : delete
편집/수정 : update
상세페이지/보기 : read
리스트/보기 : readList
엑셀다운로드 : downloadExcel
*/
export const VERSION_MENU: PermissionTableRowType = {
  name: '버전',
  key: 'VERSION_MANAGE',
  subRows: [
    {
      name: '버전 관리',
      key: PERMISSION_SUBJECTS.VERSION,
      permissions: [
        PERMISSION_ACTIONS.READLIST,
        PERMISSION_ACTIONS.READ,
        PERMISSION_ACTIONS.CREATE,
        PERMISSION_ACTIONS.UPDATE,
      ],
      subRows: [
        {
          name: '리스트 조회',
          key: PERMISSION_SUBJECTS.VERSION,
          permissions: [PERMISSION_ACTIONS.READLIST],
        },
        {
          name: '버전 등록',
          key: PERMISSION_SUBJECTS.VERSION,
          permissions: [PERMISSION_ACTIONS.CREATE],
        },
        {
          name: '버전 편집',
          key: PERMISSION_SUBJECTS.VERSION,
          permissions: [PERMISSION_ACTIONS.READ, PERMISSION_ACTIONS.UPDATE],
        },
      ],
    },
  ],
};
